import Image from "next/image";

interface Props {
  previewUrl: string;
  isSaving: boolean;
}

export default function PendingImageCarouselItem({
  previewUrl,
  isSaving,
}: Props) {
  return (
    <div className="w-full">
      <div className="relative aspect-[16/9] rounded-lg overflow-hidden">
        <Image
          src={previewUrl}
          alt={isSaving ? "Saving..." : "Uploading..."}
          fill
          className="object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            <span className="text-white text-sm font-medium">
              {isSaving ? "Saving..." : "Uploading..."}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
